import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

import DashboardPage from "@/admin/dashboard/page";
import { clearHighlightedBooking } from "@/slices/initialDateSlice";

export const Route = createFileRoute("/app/$storeId/")({
    validateSearch: (search) => ({
        date: typeof search.date === "string" ? search.date : undefined,
        bookingId: typeof search.bookingId === "string" ? search.bookingId : undefined,
    }),
    component: RouteComponent,
});

function RouteComponent() {
    const dispatch = useDispatch();

    useEffect(() => {
        return () => {
            dispatch(clearHighlightedBooking());
        };
    }, [dispatch]);

    return <DashboardPage />;
}
